import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'kd-slds-modal',
    templateUrl: './slds-modal.component.html',
    styleUrls: ['./slds-modal.component.scss']
})
export class SldsModalComponent {

    @Input()
    heading: string;

    @Input()
    open: boolean;
    @Output()
    openChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() { }

    close(): void {
        this.open = false;
        this.openChange.emit(this.open);
    }
}
